
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 15 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.514 3a1.76 1.76 0 010-2.486A1.76 1.76 0 013 .514L4.864 2.38l1.243-1.243L7.972 3 3 7.972 1.136 6.107l1.242-1.242L.514 3zM11.292 8.804c1.437 1.436 2.77 3.247 3.569 4.844l.142.283-1.07 1.07-.283-.142c-1.597-.799-3.408-2.133-4.844-3.569L4.867 7.351l2.486-2.486 3.94 3.94z"}})])
          )
        }
      }
    